export const EVENTS = {
  logout: "logout", //登出
};

const eventMap = {};

export const addLogoutListner = (cb) => {
  if (eventMap[EVENTS.logout]) {
    eventMap[EVENTS.logout].push(cb);
  } else {
    eventMap[EVENTS.logout] = [cb];
  }
  // console.log("typeof++", typeof eventMap[EVENTS.logout][0]);
};

export const notifyLogout = () => {
  if (eventMap[EVENTS.logout]) {
    eventMap[EVENTS.logout].forEach((fn) => {
      fn();
    });
  }
};

export const removeLogoutListner = () => {
  eventMap[EVENTS.logout] = [];
};
